export default __webpack_public_path__ + "static/media/ai03.1445f045.png";